import {CTBSingleTypePage as Base} from "./SingleType";
import {loader} from "./loader";

const CTBSingleTypePage = Object.assign(Base, {loader})
export {CTBSingleTypePage}